import * as React from "react"
import type { SVGProps } from "react"
const SvgLayoutGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 9.57v-4h4v4zm0 10h4v-4H5zm10-10v-4h4v4zm0 10h4v-4h-4zM3.6 10.98q.59.6 1.41.6h4q.82 0 1.41-.6.6-.59.59-1.4v-4q0-.84-.59-1.42A2 2 0 0 0 9 3.57H5q-.82 0-1.41.59A2 2 0 0 0 3 5.57v4q0 .82.59 1.41Zm0 10q.59.6 1.41.6h4q.82 0 1.41-.6.6-.59.59-1.4v-4q0-.84-.59-1.42A2 2 0 0 0 9 13.57H5q-.82 0-1.41.59A2 2 0 0 0 3 15.57v4q0 .82.59 1.41Zm10-10q.59.6 1.41.6h4q.83 0 1.41-.6.6-.59.59-1.4v-4q0-.84-.59-1.42A2 2 0 0 0 19 3.57h-4q-.83 0-1.41.59A2 2 0 0 0 13 5.57v4q0 .82.59 1.41Zm0 10q.59.6 1.41.6h4q.83 0 1.41-.6.6-.59.59-1.4v-4q0-.84-.59-1.42a2 2 0 0 0-1.41-.59h-4q-.83 0-1.41.59a2 2 0 0 0-.59 1.41v4q0 .82.59 1.41"
    />
  </svg>
)
export default SvgLayoutGrid
